export const getJwt = () => {
  console.log(localStorage);
  return localStorage.getItem('token');
};
